import React from 'react';
import { FaExternalLinkAlt } from 'react-icons/fa';
import zeroOneLogo from '../assets/images/zeroone-it-solutions-logo.jpg';
import peratiLogo from '../assets/images/Perati.jpg';

const Experience = () => {
    const experiences = [
        {
            date: '2026',
            title: 'Full-Stack Developer',
            company: 'ZeroOne I.T Solutions',
            logo: zeroOneLogo,
            logoAlt: 'ZeroOne I.T Solutions logo',
            description: 'Deployed the POS system for Soti Bakery & Convenience, a local bakery and store. Trained staff on order processing, inventory tracking, and sales reporting workflows. System includes role-based access with Super Admin, Admin, and Cashier logins for controlled operations and is used daily for checkout and inventory management.',
            technologies: ['React 19', 'Redux', 'Node.js', 'Express.js', 'MySQL', 'Sequelize ORM', 'Socket.io', 'JWT', 'Role-based Access Control', 'Real-time Updates', 'Multi-tenant Architecture', 'REST API', 'Production Deployment', 'Staff Training', 'Git']
        },
        {
            date: '2024 — 2025',
            title: 'Full-Stack Developer',
            company: 'ZeroOne I.T Solutions',
            logo: zeroOneLogo,
            logoAlt: 'ZeroOne I.T Solutions logo',
            description: 'Developed and deployed a custom POS system for Paypayan, a food store offering inasal, coffee, frappe, noodles, and other menu items. Built features for order processing, inventory monitoring, and sales tracking to support daily operations. The system is used in real time for fast and reliable checkout and reporting.',
            technologies: ['React 19', 'Redux', 'Node.js', 'Express.js', 'MySQL', 'Sequelize ORM', 'Socket.io', 'JWT', 'Role-based Access Control', 'Real-time Updates', 'Multi-tenant Architecture', 'REST API', 'Production-ready', 'Git']
        },
        {
            date: '2025',
            title: 'Data Labeler',
            company: 'micro1 (Freelance)',
            website: 'micro1.ai',
            description: 'Responsible for analyzing video content and providing accurate descriptions, labels, and tags for AI and machine learning applications. Collaborates with the team to maintain annotation quality and consistency across datasets.',
            technologies: ['AI/ML', 'Data Annotation', 'Video Analysis', 'Dataset Quality Control']
        },
        {
            date: '2023',
            title: 'Flutter Developer',
            company: 'PERATI (Startup Contributor)',
            logo: peratiLogo,
            logoAlt: 'PERATI logo',
            description: 'Built frontend mobile features for PERATI, a fleet management solution, using Flutter. Implemented UI components, real-time operational workflows, and state management for reliable app behavior. Collaborated with the team to plan, prototype, and refine features while coordinating API integration with backend developers.',
            technologies: ['Flutter', 'Dart', 'Mobile Development', 'UI/UX', 'State Management']
        },
        {
            date: '2024',
            title: 'AI Data Annotator',
            company: 'Outlier AI (Architectural Floor Plan Project)',
            website: 'outlier.ai/about-us',
            description: 'Annotated and measured architectural floor plans, including windows, doors, and walls, to create accurate datasets for AI model training. Ensured consistent labeling across contributors, identified errors to improve dataset quality, and suggested improvements to annotation tools and workflow.',
            technologies: ['AI/ML', 'Data Annotation', 'Architectural Analysis', 'Quality Assurance', 'Dataset Preparation']
        },
        {
            date: '2020 — 2025',
            title: 'Quality Assurance (QA)',
            company: 'Remotasks (Freelance)',
            website: 'remotasks.com',
            description: 'Reviewed and validated AI training data across multiple projects, ensuring accuracy and consistency in annotations. Evaluated 2D and 3D datasets for autonomous vehicles, pedestrians, and LiDAR projects. Identified annotation errors, provided feedback to improve data quality, and maintained high standards across diverse workflows to support AI model development.',
            technologies: ['Quality Assurance', 'Data Validation', 'LiDAR', '3D Annotation', '2D Annotation', 'Autonomous Vehicles', 'Computer Vision', 'AI/ML']
        },
        {
            date: '2020',
            title: 'Technical Support Intern',
            company: 'Microtrade GCM Corporation',
            website: 'https://web.facebook.com/people/Microtrade-GCM-Corporation/100063968861380/?sk=about_details',
            description: 'Performed hardware repairs and maintenance on computer systems, ensuring optimal performance. Provided technical support to clients, troubleshooting and resolving software and hardware issues. Managed basic CCTV monitoring and system maintenance, ensuring consistent operation of surveillance equipment.',
            technologies: ['Hardware Repair', 'Technical Support', 'CCTV Systems', 'System Maintenance', 'Troubleshooting']
        }
    ];

    return (
        <section id="experience" className="section" aria-labelledby="experience-heading">
            <h2 id="experience-heading" className="section-title">Experience</h2>
            <div className="section-content">
                {experiences.map((exp, index) => (
                    <div key={index} className="experience-item">
                        <div className="experience-date">{exp.date}</div>
                        <div className="experience-content">
                            <h3 className="experience-title">{exp.title}</h3>
                            <div className="experience-company">
                                {exp.logo && (
                                    <img
                                        src={exp.logo}
                                        alt={exp.logoAlt || `${exp.company} logo`}
                                        className="experience-logo"
                                        loading="lazy"
                                    />
                                )}
                                {exp.company}
                                {exp.website && (
                                    <a
                                        href={exp.website.startsWith('http') ? exp.website : `https://${exp.website}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="experience-inline-link"
                                        title={`Visit ${exp.website}`}
                                    >
                                        <FaExternalLinkAlt />
                                    </a>
                                )}
                            </div>
                            <p className="experience-description">{exp.description}</p>
                            <ul className="tech-list">
                                {exp.technologies.map((tech, techIndex) => (
                                    <li key={techIndex} className="tech-item">{tech}</li>
                                ))}
                            </ul>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default Experience;
